// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"5eb5cb372437599d1079","522":"c423dfe70309e7fc6855"}[chunkId] + ".js";
};